// extracted by mini-css-extract-plugin
export default {"fileBox":"uOfHWfQATyJi2JAu_Ieu"};